import { v4 as uuidv4 } from 'uuid';
import { db } from '@/database/db';
import type { Opportunity } from '@/types/opportunity';

export async function createOpportunity(
  input: Omit<Opportunity, 'opportunityId' | 'sequenceOrder' | 'timestamp'>
): Promise<Opportunity> {
  const sessionOpps = await db.opportunities
    .where('sessionId')
    .equals(input.sessionId)
    .count();

  const opportunity: Opportunity = {
    opportunityId: uuidv4(),
    sequenceOrder: sessionOpps + 1,
    timestamp: new Date(),
    ...input,
  };

  await db.opportunities.add(opportunity);
  return opportunity;
}

export async function getOpportunitiesBySession(
  sessionId: string
): Promise<Opportunity[]> {
  return db.opportunities
    .where('sessionId')
    .equals(sessionId)
    .sortBy('sequenceOrder');
}

export async function getOpportunity(
  opportunityId: string
): Promise<Opportunity | undefined> {
  return db.opportunities.get(opportunityId);
}

export async function updateOpportunity(
  opportunityId: string,
  updates: Partial<Opportunity>
): Promise<void> {
  await db.opportunities.update(opportunityId, updates);
}

export async function deleteOpportunity(opportunityId: string): Promise<void> {
  await db.opportunities.delete(opportunityId);
}

export async function getOpportunityCountForHCW(
  sessionId: string,
  hcwCode: string
): Promise<number> {
  return db.opportunities
    .where('sessionId')
    .equals(sessionId)
    .filter((opp) => opp.observedHCWCode === hcwCode)
    .count();
}

// Export as a single object for easier imports
export const opportunityStorage = {
  create: createOpportunity,
  getBySessionId: getOpportunitiesBySession,
  getById: getOpportunity,
  update: updateOpportunity,
  delete: deleteOpportunity,
};
